import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { Check, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/LanguageContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const OwnerSuccessPage = () => {
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const [listingId, setListingId] = useState(null);

  useEffect(() => {
    const sessionId = searchParams.get("session_id");
    const returnedListingId = searchParams.get("listing_id");
    
    if (sessionId && returnedListingId) {
      setListingId(returnedListingId);
      pollPaymentStatus(sessionId, 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const pollPaymentStatus = async (sessionId, attempts) => {
    if (attempts >= 10) {
      setStatus("timeout");
      return;
    }

    try {
      const response = await axios.get(`${API}/checkout/status/${sessionId}`);
      
      if (response.data.payment_status === "paid") {
        setStatus("success");
      } else if (response.data.status === "expired") {
        setStatus("expired");
      } else {
        setTimeout(() => pollPaymentStatus(sessionId, attempts + 1), 2000);
      }
    } catch (error) {
      // Error checking payment status
      setStatus("error");
    }
  };

  return (
    <div className="pt-36 pb-20 min-h-screen bg-bone">
      <div className="max-w-2xl mx-auto px-6 text-center">
        <div className="bg-white rounded-3xl p-12 shadow-soft">
          {status === "checking" && (
            <>
              <Loader2 className="w-16 h-16 text-primary mx-auto mb-6 animate-spin" />
              <h1 className="font-heading text-2xl font-medium text-charcoal mb-4">
                Vérification du paiement...
              </h1>
            </>
          )}

          {status === "success" && (
            <>
              <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <Check className="w-10 h-10 text-white" />
              </div>
              <h1 className="font-heading text-3xl font-medium text-charcoal mb-4">
                {t('ownerPage.success.title')}
              </h1>
              <p className="text-muted-foreground mb-8">
                {t('ownerPage.success.message')}
              </p>
              <div className="flex gap-4 justify-center">
                <Link to={`/property/${listingId}`}>
                  <Button className="rounded-full px-8">
                    {t('ownerPage.success.viewProperty')}
                  </Button>
                </Link>
                <Link to="/properties">
                  <Button variant="outline" className="rounded-full px-8">
                    Voir toutes les propriétés
                  </Button>
                </Link>
              </div>
            </>
          )}

          {(status === "expired" || status === "error" || status === "timeout") && (
            <>
              <div className="w-20 h-20 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-3xl text-white">!</span>
              </div>
              <h1 className="font-heading text-2xl font-medium text-charcoal mb-4">
                Erreur de paiement
              </h1>
              <p className="text-muted-foreground mb-8">
                Le paiement n'a pas pu être vérifié. Veuillez réessayer.
              </p>
              <Link to="/owner">
                <Button className="rounded-full px-8">Réessayer</Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default OwnerSuccessPage;
